import { render } from "./UiOneCheckboxReadOnly.pug?vue&type=template&id=89a01166&lang=pug"
import script from "./UiOneCheckboxReadOnly.js?vue&type=script&lang=js"
export * from "./UiOneCheckboxReadOnly.js?vue&type=script&lang=js"

import "../UiOneCheckbox.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__